import React, { useContext, useReducer } from "react";
import { isEmpty } from "lodash";
import { getNewPhoneOTP, getOldPhoneOTP, verifyNewPhoneOTP, verifyOldPhoneOTP } from "../../../../api/custAccountApi";
import { useCustomerAccount } from "../../AccountProvider";
import { LoadingContext } from "../../LoadingProvider";
import VerifyPhoneModal from "./VerifyPhoneModal";
import { getGetOtpForm, getVerifyOtpForm } from "./Forms";
import { getErrorCode, handleApiError } from "../../../../utils/errors";
import { formatPhoneNumber2, getTMXSessionID } from "../../../../utils";
import analytics from "../../../../utils/analytics";
import { MESSAGE_TYPE } from "../../../../constants/messages";
import { MESSAGE } from "../../../../constants";
import { useCommonContext } from "../../CommonProvider";
import { FieldError } from "../../../common/fields";
import { NewVerifyOtpModal } from "../../../NewVerifyOtpModal";
import PhoneEditForm from "../../../PhoneEditForm";
import { buildOtpTicket, buildOtpTicketWithoutUserId } from "../../../NewVerifyOtpModal/ApiUtils";
import {Link, Typography} from "@one-thd/sui-atomic-components";
import {ApiContext} from "../../../../contexts/ApiContext";
import { FEATURE_SWITCHES, isFeatureSwitchEnabled, isUserB2B } from "../../../../utils";
import { selectAutomationIdBasedOnComponent } from "../../../../utils/automationIds";

const OPEN_MODAL = "OPEN_MODAL";
const INIT_OTP_MODAL = "INIT_OTP_MODAL";
const CLOSE_MODAL = "CLOSE_MODAL";
const PHONE_VERIFIED_MODE = "PHONE_VERIFIED_MODE";
const PHONE_UNVERIFIED_MODE = "PHONE_UNVERIFIED_MODE";
const NEW_PHONE_MODE = "NEW_PHONE_MODE";

// Modal action names
const GET_OTP_SUCCESS = "GET_OTP_SUCCESS";
const VERIFY_OLD_OTP_SUCCESS = "VERIFY_OLD_OTP_SUCCESS";
const VERIFY_NEW_OTP_SUCCESS = "VERIFY_NEW_OTP_SUCCESS";
const UPDATE_AUTH_ID = "UPDATE_AUTH_ID";
const SET_MODAL_HEADER = "SET_MODAL_HEADER";
const SET_PHONE_NUMBER = "SET_PHONE_NUMBER";
const SET_MODAL_INIT_ERROR = "SET_MODAL_INIT_ERROR";
const SET_EVOICE_ERROR = "SET_EVOICE_ERROR";
const CLEAN_ERRORS = "CLEAN_ERRORS";
export const SET_MODAL_TYPE = "SET_MODAL_TYPE";
export const SET_MODAL_ORIGIN = "SET_MODAL_ORIGIN";
export const SET_CONTEXT = "SET_CONTEXT";

// Modal types
export const OLD_PHONE_VERIFY_OTP = "OLD_PHONE_VERIFY_OTP";
export const OLD_PHONE_VERIFY_EVOICE_OTP = "OLD_PHONE_VERIFY_EVOICE_OTP";
export const NEW_PHONE_GET_OTP = "NEW_PHONE_GET_OTP";
export const NEW_PHONE_VERIFY_OTP = "NEW_PHONE_VERIFY_OTP";
export const NEW_PHONE_VERIFY_EVOICE_OTP = "NEW_PHONE_VERIFY_EVOICE_OTP";

const ADD_PHONE_HEADER = "Add and Verify Your Number";
const addNumberButtonAutomationId = "phone-section--button-add-new";


const initialState = () => ({
  modalOpen: false,
  verifyNewPhoneErrors: 0
});

function reducer(state, action) {
  const newState = { ...state };
  switch (action.type) {
    case OPEN_MODAL:
      newState.modalOpen = true;
      break;
    case INIT_OTP_MODAL:
      newState.emailEditContext = action.emailEditContext;
      newState.showOtpModal = true;
      return newState;
    case SET_CONTEXT:
      newState.emailEditContext = action.emailEditContext;
      break;
    case SET_MODAL_TYPE:
      newState.modalType = action.payload.type;
      break;
    case SET_PHONE_NUMBER:
      newState.phoneNumber = action.payload.phoneNumber;
      break;
    case SET_MODAL_ORIGIN:
      newState.modalOrigin = action.payload.modalOrigin;
      break;
    case SET_MODAL_HEADER:
      newState.modalHeader = action.payload.modalHeader;
      break;
    case GET_OTP_SUCCESS:
      newState.otpTicket = action.payload.otpTicket;
      newState.phoneNumber = action.payload.phoneNumber;
      break;
    case VERIFY_OLD_OTP_SUCCESS:
      newState.userId = action.payload.userId;
      break;
    case SET_MODAL_INIT_ERROR:
      newState.errorMessage = action.payload.errorMessage;
      break;
    case SET_EVOICE_ERROR:
      newState.evoiceErrorMessage = action.payload.errorMessage;
      break;
    case CLEAN_ERRORS:
      delete newState.evoiceErrorMessage;
      delete newState.errorMessage;
      break;
    case UPDATE_AUTH_ID:
      newState.otpTicket.authId = action.payload.authId;
      return newState;
    case CLOSE_MODAL:
      return initialState();
    default:
      break;
  }

  return newState;
}

const PhoneDisplay = (props) => {
  const {
    formattedPhone,
    phone,
    mode,
    buttonAction,
    buttonText,
    buttonAutomationId,
    errorMessage,
    openConditionsAndTermsModal,
  } = props;

  return (
    <>
      <div className="col__12-12 col__3-12--xs col__4-12--sm col__4-12--md col__4-12--lg u--paddingNone u--paddingSmall-right">
        <Typography variant='h6'>
          Contact Phone
        </Typography>
      </div>
      <div className="col__10-12 col__7-12--xs col__6-12--sm col__6-12--md col__6-12--lg u--paddingNone">
        <div className="u--paddingNone">{formattedPhone}
          {phone.isVerified
            && (
              <span className="u--paddingSmall-left verify-phone-link-success">
                    Verified
                  </span>
            )}
          {(mode === PHONE_UNVERIFIED_MODE && (isFeatureSwitchEnabled(FEATURE_SWITCHES.ENABLE_B2B_PHONE_VERIFICATION) || !isUserB2B()))
            && (
              <button
                type="button"
                onClick={()=>{openConditionsAndTermsModal();}}
                className="u--paddingSmall-left u__default-link text-small"
                data-automation-id={selectAutomationIdBasedOnComponent("phoneVerification", "verifyFlow")}
              >
                Verify
              </button>
            )}
        </div>
      </div>
      <div
        className="col__2-12 col__2-12--xs col__2-12--sm col__2-12--md col__2-12--lg u--paddingNone u__text-align--right"
      >
        <button
          type="button"
          onClick={buttonAction}
          className="u--paddingSmall-left u__default-link"
          data-automation-id={buttonAutomationId}
        >
          <Link>{buttonText}</Link>
        </button>
      </div>
      {!isEmpty(errorMessage)
        && (
          <div className="col__12-12 form-input--error u--paddingNone u--paddingXsmall-top">
            <FieldError errors={[errorMessage]}/>
          </div>
        )}
    </>
  );
}

const PhoneEdit = (props) => {
  const { primaryPhone, closeModal, onClickInitPhoneNumberEdit, isAddingAPhone, buttonToSaveChanges, verifyInlineAddedPhone, errorMessage, cleanPreviousErrors, isModalOpen } = props;

  const helperFunction = (justAddedNumber) => {
    cleanPreviousErrors();
    buttonToSaveChanges();
    verifyInlineAddedPhone(justAddedNumber);
  }

  return (
    <>
      <Typography variant='h6'>
        Phone Number
      </Typography>

      <PhoneEditForm primaryPhone={primaryPhone} closeForm={closeModal} onSubmit={isAddingAPhone ? helperFunction : onClickInitPhoneNumberEdit}/> 
      {!isEmpty(errorMessage) && !isModalOpen
        && (
          <div className="col__12-12 form-input--error u--paddingNone u--paddingXsmall-top">
            <FieldError errors={[errorMessage]}/>
          </div>
        )}
    </>
  );
}

const PhoneSection = (props) => {
  const {
    currentEmail, phone, onVerificationSuccess, isEditingPhone, onEditPhone, onDoneEditing
  } = props;
  const { showLoading, hideLoading } = useContext(LoadingContext);
  const {setApiContext, apiContext} = useContext(ApiContext);
  const { addAlert } = useCommonContext();

  const context = useCustomerAccount();
  const { account, setStale } = context;
  const phones = account?.profilePhones?.phone || [];
  let primaryPhone = null;
  let isPhoneVerified = false;

  phones.forEach((profilePhone) => {
    if (profilePhone.primaryFlag === "Y") primaryPhone = profilePhone.number;
    if ((profilePhone.primaryFlag === "Y") && (profilePhone.phoneVerified === "Y")) isPhoneVerified = true;
  });
  let mode = NEW_PHONE_MODE;
  if (primaryPhone) {
    mode = isPhoneVerified ? PHONE_VERIFIED_MODE : PHONE_UNVERIFIED_MODE;
  }

  const [state, dispatch] = useReducer(reducer, initialState());

  // Create local helpers to dispatch the various modal actions
  const openModal = () => {
    dispatch({ type: OPEN_MODAL });
  };
  const closeModal = () => {
    dispatch({ type: CLOSE_MODAL });
    onDoneEditing();
    setErrorOnVerifyingNumber(undefined);
  };
  const cleanPreviousErrors = () => {
    dispatch({ type: CLEAN_ERRORS });
  };
  const setModalOrigin = (modalOrigin) => {
    dispatch({ type: SET_MODAL_ORIGIN, payload: { modalOrigin } });
  };
  const setModalHeader = (modalHeader) => {
    dispatch({ type: SET_MODAL_HEADER, payload: { modalHeader } });
  };
  const setModalType = (type) => {
    dispatch({ type: SET_MODAL_TYPE, payload: { type } });
  };
  const getOtpSuccess = (response, phoneNumber) => {
    dispatch({
      type: GET_OTP_SUCCESS,
      payload: { otpTicket: response.data, phoneNumber }
    });
  };
  const setModalInitError = (errorMessage) => {
    dispatch({
      type: SET_MODAL_INIT_ERROR,
      payload: { errorMessage }
    });
  };
  const setEvoiceError = (errorMessage) => {
    dispatch({
      type: SET_EVOICE_ERROR,
      payload: { errorMessage }
    });
  };
  const initOtpChoiceModal = (emailEditContext) => {
    return {
      type: INIT_OTP_MODAL,
      emailEditContext
    };
  };
  const setContext = (context) => {
    return {
      type: SET_CONTEXT,
      emailEditContext: context
    };
  };
  const openPhoneForm = () => {
    setModalOrigin("phoneEdit");
    onEditPhone();
  };
  const openPhoneFormNoPhone = () => {
    onEditPhone();
  }
  const updateAuthID = (authId) => {
    dispatch({
      type: UPDATE_AUTH_ID,
      payload: {authId}
    });
  };
  const onPhoneEditSelect = (context) => dispatch(initOtpChoiceModal(context));

  // Callbacks
  const getNewOTPSuccessCallback = (phoneNumber, response) => {
    getOtpSuccess(response, phoneNumber);
    setModalType(NEW_PHONE_VERIFY_OTP);
  };
  const verifyOldOTPSuccessCallback = (response) => {
    dispatch({ type: VERIFY_OLD_OTP_SUCCESS, payload: { userId: response.data.userId } });
    setModalType(NEW_PHONE_GET_OTP);
  };
  const verifyNewPhoneOTPSuccessCallback = () => {
    setStale();
    analytics.postSettingsSubmissionEvent("security: phone add success");
    dispatch({ type: VERIFY_NEW_OTP_SUCCESS });
    onVerificationSuccess(mode === PHONE_UNVERIFIED_MODE);
    closeModal();
  };
  const verifyOTPFailureCallback = (error) => {
    const errorMessage = handleApiError(error, "verify phone");
    const errorCode = getErrorCode(error);
    if (errorCode === "AUTH_ERR_125") {
      addAlert(MESSAGE_TYPE.DANGER, MESSAGE.OTP_ATTEMPTS_EXHAUSTED);
      closeModal();
    } else {
      form.setStatus([errorMessage]);
    }
    if((errorCode === "VRFYPH_ERR_009") && (!!error?.response?.headers?.authid)){
      updateAuthID(error?.response?.headers?.authid);
    }
  };
  const activateAlertMessage = (errorCode) => {
    if (errorCode === "AUTH_ERR_125") {
      addAlert(MESSAGE_TYPE.DANGER, MESSAGE.OTP_ATTEMPTS_EXHAUSTED);
    }
  };
  const initiateOtpChoiceFlow = (email, primaryPhoneNumber, isPhoneVerified, newPhoneNumber) => {
    const editFormContext = {};
    editFormContext.email = email;
    editFormContext.phone = primaryPhoneNumber;
    editFormContext.isPhoneVerified = isPhoneVerified;
    editFormContext.newPhoneNumber = newPhoneNumber;
    onPhoneEditSelect(editFormContext);
  };

  // Initialize the different forms
  const forms = {
    getNewPhoneOTP: getGetOtpForm(mode === PHONE_UNVERIFIED_MODE ? primaryPhone : "", account?.profile?.emailId, state.userId, account?.encryptVerifiedPhoneToken, getNewOTPSuccessCallback, showLoading, hideLoading),
    verifyOldPhoneOTP: getVerifyOtpForm((values) => verifyOldPhoneOTP(values.otp, state.otpTicket, state.phoneNumber, account), verifyOldOTPSuccessCallback, verifyOTPFailureCallback, showLoading, hideLoading),
    verifyNewPhoneOTP: getVerifyOtpForm((values) => verifyNewPhoneOTP(values.otp, state.otpTicket, state.phoneNumber, account), verifyNewPhoneOTPSuccessCallback, verifyOTPFailureCallback, showLoading, hideLoading)
  };

  // Pick the right form to send to the modal
  let form;
  switch (state.modalType) {
    case NEW_PHONE_GET_OTP:
      form = forms.getNewPhoneOTP;
      break;
    case OLD_PHONE_VERIFY_OTP:
    case OLD_PHONE_VERIFY_EVOICE_OTP:
      form = forms.verifyOldPhoneOTP;
      break;
    case NEW_PHONE_VERIFY_OTP:
    case NEW_PHONE_VERIFY_EVOICE_OTP:
      form = forms.verifyNewPhoneOTP;
      break;
    default:
      break;
  }

  // Determine the action for the main phone verification edit button on security page
  let buttonAction;
  let buttonAutomationId;
  let buttonToSaveChanges;
  switch (mode) {
    case PHONE_UNVERIFIED_MODE:
      buttonAction = () => {
        openPhoneForm();
      };
      buttonAutomationId = selectAutomationIdBasedOnComponent("phone", "edit", false);
      break;
    case PHONE_VERIFIED_MODE:
      buttonAction = () => {
        openPhoneForm();
        analytics.postSettingsSubmissionEvent("security: edit phone link");
      };
      buttonAutomationId = selectAutomationIdBasedOnComponent("phone", "edit", true);
      break;
    case NEW_PHONE_MODE:
      buttonAction = () => {
        openPhoneFormNoPhone();
        analytics.postSettingsSubmissionEvent("security: add new phone link");
      };
      buttonToSaveChanges = () => {
        setModalType(NEW_PHONE_GET_OTP);
        setModalHeader(ADD_PHONE_HEADER);
        analytics.postOverlayEvent("verify my phone number code entry - text");
      }
      buttonAutomationId = addNumberButtonAutomationId;
      break;
    default:
      buttonAction = () => {
        setModalType(NEW_PHONE_GET_OTP);
        setModalHeader(ADD_PHONE_HEADER);
        openModal();
        analytics.postOverlayEvent("verify my phone number code entry - text");
      };
      buttonAutomationId = addNumberButtonAutomationId;
  }

  const verifyInlineAddedPhone = (justAddedNumber) => {
    showLoading();
    getNewPhoneOTP(account?.profile?.emailId, justAddedNumber, "sms", null, getTMXSessionID(), account?.encryptVerifiedPhoneToken)
      .then(({ response, error }) => {
        if (response) {
          openModal();
          getNewOTPSuccessCallback(justAddedNumber, response);
          const ticket = buildOtpTicket(response.data);
          setApiContext({
            requestOtpTicket: ticket
          });
          analytics.postOverlayEvent("verify my phone number code entry - text");
        } else {
          const errorMessage = handleApiError(error, "verify phone");
          setModalInitError(errorMessage);
        }
        hideLoading();
      });
    
  }

  const textMeANewCodeAfterVerifyingIdentity = () => {
    setErrorOnVerifyingNumber(undefined);
    showLoading();
    getNewPhoneOTP(account.profile.emailId, state?.emailEditContext?.newPhoneNumber, "sms", apiContext.persistedUserId, getTMXSessionID(), account.encryptVerifiedPhoneToken)
      .then(({ response, error }) => {
        if (response) {
          const ticket = buildOtpTicketWithoutUserId(response.data);
          setApiContext({
            requestOtpTicket: ticket
          });
          analytics.postOverlayEvent("verify my phone number code entry - text");
        } else {
          const errorMessage = handleApiError(error, "verify phone");
          setErrorOnVerifyingNumber([errorMessage]);
        }
        hideLoading();
      });
  }

  const phoneMeANewCodeAfterVerifyingIdentity = () => {
    setErrorOnVerifyingNumber(undefined);
    showLoading();
    getNewPhoneOTP(account.profile.emailId, state?.emailEditContext?.newPhoneNumber, "phone", apiContext.persistedUserId, getTMXSessionID(), account.encryptVerifiedPhoneToken)
      .then(({ response, error }) => {
        if (response) {
          const ticket = buildOtpTicketWithoutUserId(response.data);
          setApiContext({
            requestOtpTicket: ticket
          });
          analytics.postOverlayEvent("verify my phone number code entry - text");
        } else {
          const errorMessage = handleApiError(error, "verify phone");
          setErrorOnVerifyingNumber([errorMessage]);
        }
        hideLoading();
      });
  }

  const textMeANewCode = (phoneNumber) => {
    cleanPreviousErrors();
    showLoading();
    getNewPhoneOTP(account.profile.emailId, phoneNumber, "sms", null, getTMXSessionID(), account.encryptVerifiedPhoneToken)
      .then(({ response, error }) => {
        if (response) {
          openModal();
          getNewOTPSuccessCallback(phoneNumber, response);
          const ticket = buildOtpTicket(response.data);
          setApiContext({
            requestOtpTicket: ticket
          });
          analytics.postOverlayEvent("verify my phone number code entry - text");
        } else {
          const errorMessage = handleApiError(error, "verify phone");
          setModalInitError(errorMessage);
        }
        hideLoading();
      });
  }

  const phoneMeANewCodeAction = (phoneNumber) => {
    cleanPreviousErrors();
    showLoading();
    getNewPhoneOTP(account.profile.emailId, phoneNumber, "phone", state.userId, getTMXSessionID(), account.encryptVerifiedPhoneToken)
      .then(({ response, error }) => {
        if (response) { // otp successfully sent
          getNewOTPSuccessCallback(phoneNumber, response);
          const ticket = buildOtpTicket(response.data);
          setApiContext({
            requestOtpTicket: ticket
          });
          analytics.postOverlayEvent("verify my phone number code entry - text");
        } else {
          const errorMessage = handleApiError(error, "verify phone");
          setModalInitError(errorMessage);
        }
        hideLoading();
      });
  }

  const onClickInitPhoneNumberEdit = (newPhoneNumber) => {
    initiateOtpChoiceFlow(currentEmail, primaryPhone, isPhoneVerified, newPhoneNumber);
    openModal();
  };

  const openConditionsAndTermsModal = () => {
    const editFormContext = {
      phone: primaryPhone,
      newPhoneNumber: primaryPhone
    };
    dispatch(setContext(editFormContext));
    setModalOrigin("termsAndConditions");
    openModal();
  }

  const [errorOnVerifyingNumber, setErrorOnVerifyingNumber] = React.useState();

  const verifyExistingPhone = (otpChannel="sms") => {
    showLoading();

    const editFormContext = {};
    editFormContext.phone = primaryPhone;
    editFormContext.newPhoneNumber = primaryPhone;

    dispatch(setContext(editFormContext));
    getNewPhoneOTP(account.profile.emailId, primaryPhone, otpChannel, null, getTMXSessionID(), account.encryptVerifiedPhoneToken)
      .then(({ response, error }) => {
        if (response) { // otp successfully sent
          getNewOTPSuccessCallback(primaryPhone, response);
          const ticket = buildOtpTicket(response.data);
          setApiContext({
            autoToken: response.data?.autoToken,
            requestOtpTicket: ticket
          });
          setModalOrigin("verifyExistingPhone");
          openModal();
          analytics.postOverlayEvent("verify my phone number code entry - text");
        } else {
          setModalOrigin("verifyExistingPhone");
          const errorMessage = handleApiError(error, "verify phone");
          setErrorOnVerifyingNumber([errorMessage])
        }
        hideLoading();
      });
  };

  const evoiceAction = () => {
    cleanPreviousErrors();
    showLoading();
    form.resetForm();
    if (state.modalType === NEW_PHONE_VERIFY_OTP) {
      getNewPhoneOTP(account.profile.emailId, state.phoneNumber, "phone", state.userId, getTMXSessionID(), account.encryptVerifiedPhoneToken)
        .then(({ response, error }) => {
          if (response) { // otp successfully sent
            getOtpSuccess(response, state.phoneNumber);
            setModalType(NEW_PHONE_VERIFY_EVOICE_OTP);
            analytics.postOverlayEvent("verify my phone number code entry - phone call");
          } else {
            const errorMessage = handleApiError(error, "verify phone");
            setEvoiceError(errorMessage);
          }
          hideLoading();
        });
    } else {
      getOldPhoneOTP(account.profile.emailId, state.phoneNumber, "phone", account.encryptVerifiedPhoneToken, getTMXSessionID())
        .then(({ response, error }) => {
          if (response) { // otp successfully sent
            getOtpSuccess(response, state.phoneNumber);
            setModalType(OLD_PHONE_VERIFY_EVOICE_OTP);
          } else {
            const errorMessage = handleApiError(error, "verify phone");
            setEvoiceError(errorMessage);
          }
          hideLoading();
        });
    }
  };

  let formattedPhone;
  let buttonText;
  if (phone.phoneNumber) {
    buttonText = "Edit";
    const trimmedPhoneNumber = phone.phoneNumber.replace(/[^0-9]/g, "");
    formattedPhone = `${trimmedPhoneNumber.substring(0, 3)}-${trimmedPhoneNumber.substring(3, 6)}-${trimmedPhoneNumber.substring(6)}`;
  } else {
    buttonText = "Add New";
    formattedPhone = "(___) ___-____";
  }

  return (
    <div className="col__12-12 u--paddingNone-horizontal" id="verify-phone-section">
      {!isEditingPhone &&
        <PhoneDisplay formattedPhone={formattedPhone}
          phone={phone}
          mode={mode}
          openConditionsAndTermsModal={openConditionsAndTermsModal}
          buttonAction={buttonAction}
          buttonText={buttonText}
          buttonAutomationId={buttonAutomationId}
          errorMessage={state.errorMessage}/>}
      {isEditingPhone &&
        <PhoneEdit
          isModalOpen={state.modalOpen}
          cleanPreviousErrors={cleanPreviousErrors}
          primaryPhone={primaryPhone} closeModal={closeModal}
          onClickInitPhoneNumberEdit={onClickInitPhoneNumberEdit}
          buttonToSaveChanges={buttonToSaveChanges} 
          isAddingAPhone={mode==="NEW_PHONE_MODE"}
          verifyInlineAddedPhone={verifyInlineAddedPhone}
          errorMessage={state.errorMessage}
          />}
          
      {/* Exclude no phone-flows from new OTP flow */}
      {((state.modalOpen) && !(state.modalHeader === ADD_PHONE_HEADER && (state.modalType === NEW_PHONE_GET_OTP || state.modalType === NEW_PHONE_VERIFY_OTP))) && (
        <NewVerifyOtpModal
          origin={state.modalOrigin}
          isOpen={state.modalOpen}
          emailEditContext={state.emailEditContext}
          onCancelModal={closeModal}
          resetFormState={closeModal}
          errorOnVerifyingNumber={errorOnVerifyingNumber}
          activateAlertMessage={activateAlertMessage}
          verifyExistingPhone={verifyExistingPhone}
          isPhoneVerified={isPhoneVerified}
          textMeANewCodeAfterVerifyingIdentity={textMeANewCodeAfterVerifyingIdentity}
          phoneMeANewCodeAfterVerifyingIdentity={phoneMeANewCodeAfterVerifyingIdentity}
          {...props}
        />
      )}
      {state.modalHeader === ADD_PHONE_HEADER && (state.modalType === NEW_PHONE_GET_OTP || state.modalType === NEW_PHONE_VERIFY_OTP || state.modalType === NEW_PHONE_VERIFY_EVOICE_OTP) &&
        <VerifyPhoneModal
          apiContext={apiContext}
          isOpen={state.modalOpen}
          closeModal={closeModal}
          modalType={state.modalType}
          modalHeader={state.modalHeader}
          form={form}
          phoneMeANewCodeAction={()=>{phoneMeANewCodeAction(state.phoneNumber)}}
          phoneNumber={state.phoneNumber ? formatPhoneNumber2(state.phoneNumber) : ""}
          evoiceAction={evoiceAction}
          errorMessageWhileAddingAPhoneFlow={state.errorMessage}
          textMeANewCode={()=>{textMeANewCode(state.phoneNumber)}}
          evoiceErrorMessage={state.evoiceErrorMessage}
        />}
    </div>
  );
};

export default PhoneSection;
